import { type QuickBooksRunSteps, QuickBooksSyncStage } from '@ankor-io/common/types/integrations/quickbooks'
import { XeroConnectionSyncStage } from '@ankor-io/common/types/integrations/xero/types'

export const STAGE_LABELS: Record<string, string> = {
  [XeroConnectionSyncStage.LOADING_TRANSACTIONS]: 'Load Transactions',
  [XeroConnectionSyncStage.MAPPING]: 'Mapping',
  [XeroConnectionSyncStage.SYNCING_TRANSACTIONS]: 'Sync Transactions',
  [XeroConnectionSyncStage.SYNCING_ATTACHMENTS]: 'Sync Attachments',
}

export const STAGE_ORDER: XeroConnectionSyncStage[] = [
  XeroConnectionSyncStage.LOADING_TRANSACTIONS,
  XeroConnectionSyncStage.MAPPING,
  XeroConnectionSyncStage.SYNCING_TRANSACTIONS,
  XeroConnectionSyncStage.SYNCING_ATTACHMENTS,
]

export const QUICKBOOKS_STAGE_TO_STEP_TYPE: Record<string, QuickBooksRunSteps> = {
  [QuickBooksSyncStage.LOADING_TRANSACTIONS]: 'LOAD_EXPENSES',
  [QuickBooksSyncStage.MAPPING]: 'MAP_EXPENSES',
  [QuickBooksSyncStage.SYNCING_TRANSACTIONS]: 'SYNC_PURCHASES',
  [QuickBooksSyncStage.SYNCING_ATTACHMENTS]: 'SYNC_ATTACHMENTS',
}
